import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import React, { useCallback } from 'react';


function PlayButton(props) {
  const {
    onTogglePlay,
    isPlaying,
    isFeaturedClip,
  } = props;

  if (!isFeaturedClip) {
    return null;
  }

  const PlayIcon = !isPlaying ? PlayArrowIcon : PauseIcon;

  return (
    <button className="play-overlay-dark flex justify-center items-center" onClick={onTogglePlay}>
      <PlayIcon className="play-btn" />
    </button>
  );
}

export default PlayButton;
